/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';

export default class AutomationFinAIAgentCustomAnswersAnswerShowConversations extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.custom-answers.answer.show.conversations',
  };
}
